import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Zap, FileText, Star, Users, MapPin, CheckCircle2 } from 'lucide-react';
import { CTAButton } from './Shared';
export function Hero() {
  return <section className="relative bg-[#f8f6ff] text-slate-900 overflow-hidden min-h-[100svh] md:min-h-0 pt-2 pb-6 md:pt-12 md:pb-20 lg:pt-20 lg:pb-28" data-id="element-87">
      {/* Background Accents */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-brand-400 via-white to-brand-400 opacity-60" data-id="element-88"></div>
      <div className="absolute -top-40 -right-40 w-96 h-96 bg-brand-200 rounded-full blur-3xl opacity-50" data-id="element-89"></div>
      <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-brand-300 rounded-full blur-3xl opacity-30" data-id="element-90"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-91">
        <div className="max-w-3xl mx-auto" data-id="element-92">
          {/* Single Column: Copy with image inline */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="space-y-4 md:space-y-8" data-id="element-93">
            <div className="flex justify-center" data-id="element-94">
              <div className="inline-flex items-center gap-2 bg-brand-50 border border-brand-200 rounded-full px-4 py-1.5 text-xs md:text-sm font-medium text-brand-700" data-id="element-95">
                TODO TU AÑO DE CIUDADANIA RESUELTO.
              </div>
            </div>

            <div className="text-center" data-id="element-96">
              <h1 className="text-3xl sm:text-4xl md:text-4xl lg:text-5xl font-extrabold leading-[1.1] md:leading-tight text-slate-900" data-id="element-97">
                MegaPack Ciudadanía Integral — 6 tomos completos{' '}
                <span className="text-brand-600" data-id="element-98">para Docentes</span>
              </h1>
            </div>

            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="relative w-full max-w-[260px] sm:max-w-xs md:max-w-lg mx-auto py-2 md:py-4" data-id="element-99">
              <div className="absolute inset-0 bg-gradient-to-tr from-brand-400 to-brand-200 rounded-2xl blur-2xl opacity-40 transform rotate-3" data-id="element-100"></div>
              <div className="relative rounded-xl md:rounded-2xl" data-id="element-101">
                <img src="https://cdn.magicpatterns.com/uploads/cGeNaVKXJh42e11fKpjt1D/Emprendedor_Te_damos_una_solucion._(1080_x_1080_px)_(Post_de_Instagram_(45))_(3).png" alt="MegaPack Ciudadanía Integral — Plan anual completo con 6 tomos, planificaciones y bonus para docentes de secundaria" width={1080} height={1080} loading="eager" decoding="async" fetchPriority="high" className="w-full h-auto rounded-lg md:rounded-xl object-contain aspect-square drop-shadow-2xl" data-id="element-102" />
              </div>
            </motion.div>

            <div className="text-center max-w-2xl mx-auto" data-id="element-103">
              <h2 className="text-base md:text-xl text-slate-600 font-medium leading-snug md:leading-relaxed" data-id="element-104">
                +66 recursos de Ciudadanía creados para docentes que están
                hartos de improvisar. Actividades, Evaluaciones, Debates,
                alineados al currículo argentino 2026.
              </h2>
            </div>

            <div className="flex flex-wrap justify-center gap-2 md:gap-3 text-xs md:text-sm font-medium text-slate-700" data-id="element-105">
              <span className="flex items-center gap-1.5 bg-white border border-slate-200 px-3 py-1 rounded-md shadow-sm" data-id="element-106">
                <FileText className="w-3.5 h-3.5 md:w-4 md:h-4 text-brand-600" data-id="element-107" />{' '}
                100% PDF
              </span>
              <span className="flex items-center gap-1.5 bg-white border border-slate-200 px-3 py-1 rounded-md shadow-sm" data-id="element-108">
                <Zap className="w-3.5 h-3.5 md:w-4 md:h-4 text-brand-600" data-id="element-109" />{' '}
                Acceso inmediato
              </span>
              <span className="flex items-center gap-1.5 bg-white border border-slate-200 px-3 py-1 rounded-md shadow-sm" data-id="element-110">
                <MapPin className="w-3.5 h-3.5 md:w-4 md:h-4 text-brand-600" data-id="element-111" />{' '}
                🇦🇷 Currículo 2026
              </span>
            </div>

            <div className="pt-2 md:pt-4 flex flex-col items-center space-y-3 md:space-y-4" data-id="element-112">
              <CTAButton className="w-full md:w-auto text-base md:text-lg py-4 md:py-5 px-6 md:px-10" data-id="element-113">
                📚 → QUIERO MI CIUDADANÍA PACK AHORA
              </CTAButton>

              <div className="flex flex-wrap items-center justify-center gap-4 text-sm text-slate-500" data-id="element-114">
                <span className="flex items-center gap-1" data-id="element-115">
                  <ShieldCheck className="w-4 h-4 text-green-600" data-id="element-116" /> Garantía 7
                  días
                </span>
                <span className="flex items-center gap-1" data-id="element-117">
                  <CheckCircle2 className="w-4 h-4 text-green-600" data-id="element-118" /> Pago
                  seguro
                </span>
                <span className="flex items-center gap-1" data-id="element-119">
                  <Zap className="w-4 h-4 text-brand-600" data-id="element-120" /> Mercado Pago
                </span>
              </div>
            </div>

            <div className="hidden md:grid grid-cols-2 md:grid-cols-4 gap-4 pt-8 border-t border-slate-200" data-id="element-121">
              <div data-id="element-122">
                <div className="text-xl font-bold text-slate-900" data-id="element-123">+1.200</div>
                <div className="text-xs text-slate-500 uppercase tracking-wider mt-1" data-id="element-124">
                  Docentes | Todo el país
                </div>
              </div>
              <div data-id="element-125">
                <div className="text-xl font-bold text-slate-900" data-id="element-126">6 Tomos</div>
                <div className="text-xs text-slate-500 uppercase tracking-wider mt-1" data-id="element-127">
                  Listos para usar
                </div>
              </div>
              <div data-id="element-128">
                <div className="text-xl font-bold text-slate-900 flex items-center gap-1" data-id="element-129">
                  4.9/5{' '}
                  <Star className="w-4 h-4 text-amber-400 fill-amber-400" data-id="element-130" />
                </div>
                <div className="text-xs text-slate-500 uppercase tracking-wider mt-1" data-id="element-131">
                  Calificación
                </div>
              </div>
              <div data-id="element-132">
                <div className="text-xl font-bold text-slate-900" data-id="element-133">🇦🇷</div>
                <div className="text-xs text-slate-500 uppercase tracking-wider mt-1" data-id="element-134">
                  Todo el país | Secundaria
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}
export function TestimonialsHero() {
  const testimonials = [{
    quote: 'En una sola tarde dejé armado todo el año de Ciudadanía. Me liberó cabeza para enfocarme en los pibes.',
    name: 'SV — SOFÍA V.',
    location: 'MENDOZA | SECUNDARIA'
  }, {
    quote: 'Los chicos de 2° año pasaron de mirar el celular a discutir con fundamentos. Las actividades los atrapan al toque.',
    name: 'DA — DIEGO A.',
    location: 'LA PLATA | SECUNDARIA'
  }, {
    quote: 'Llevé la planificación anual, ESI y EAI el primer día de clases. La directora pensó que había trabajado todo el verano.',
    name: 'CB — CAROLINA B.',
    location: 'SALTA | SECUNDARIA'
  }];
  return <section className="bg-white py-12 border-y border-slate-200" data-id="element-135">
      <div className="container mx-auto px-4" data-id="element-136">
        <div className="grid md:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-137">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-slate-50 border border-slate-200 p-6 rounded-xl" data-id="element-138">
              <div className="flex gap-1 mb-4" data-id="element-139">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 text-amber-400 fill-amber-400" data-id="element-140" />)}
              </div>
              <p className="text-slate-700 text-sm md:text-base italic mb-6" data-id="element-141">
                "{t.quote}"
              </p>
              <div className="mt-auto" data-id="element-142">
                <p className="text-slate-900 font-bold text-sm" data-id="element-143">{t.name}</p>
                <p className="text-brand-600 text-xs mt-0.5" data-id="element-144">{t.location}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}